import {
  StatusInterface,
  SurveyAnswerValueInterface,
  SurveyListInterface,
  UserSurveyInterface,
} from '@elearning-platform/api-types/interfaces';
import { AxiosResponse } from 'axios';

import { phpApi } from '../default';

export const getLists: () => Promise<AxiosResponse<SurveyListInterface>> = (): Promise<AxiosResponse<SurveyListInterface>> =>
  phpApi.get('/api/survey/list');

export const getQuestions: (id: number) => Promise<AxiosResponse<UserSurveyInterface>>
= (id: number): Promise<AxiosResponse<UserSurveyInterface>> => phpApi.post(`/api/survey/${id}/init`);

export const sendQuestion: (id: number, answers: SurveyAnswerValueInterface[]) => Promise<StatusInterface>
= (id: number, answers: SurveyAnswerValueInterface[]): Promise<StatusInterface> => phpApi.post(`/api/survey/${id}/save`, { answers });

export const finishForm: (id: number) => Promise<void>
= (id: number): Promise<void> => phpApi.post(`/api/survey/${id}/finish`);
